module.exports = __webpack_public_path__ + "img/piggy-bank.c98d25be.svg";